import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _04_PLANT_ENERGY:Partial<EcosystemServiceModel> ={
  id:'plant-energy',
  pos:4,
  image: "/images/ecoservices/plant_energy.jpg",
  code: ["1.1.5.3", "1.1.1.3"],
  unit:'plant energy',
  assetType:'other',
  serviceType: 'provisioning',
  valuationMethods:[
    {
      id: 'market',
      name:"Market prices",
      unit: "m3",
      element: "wood from plants",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
